import { FC } from 'react';
import { StanButton } from '@/components';

interface BroadcastFormActionsProps {
    canSaveDraft: boolean;
    isSent: boolean;
    isScheduled: boolean;
    disabled: boolean;
    onTestSend: () => void;
    onSaveDraft: () => void;
    onSend: () => void;
}

export const BroadcastFormActions: FC<BroadcastFormActionsProps> = ({
    canSaveDraft,
    isSent,
    isScheduled,
    disabled,
    onTestSend,
    onSaveDraft,
    onSend,
}) => {
    return (
        <div className='flex flex-col gap-x-3 sm:flex-row'>
            {/* Mobile: Test Send and Save Draft side by side, Desktop: Only Test Send */}
            <div className='flex gap-2 sm:block'>
                <StanButton
                    name='broadcast-test-send'
                    variant='outline'
                    onClick={onTestSend}
                    disabled={disabled}
                    className='flex-1 sm:w-auto'
                >
                    Test Send
                </StanButton>
                <StanButton
                    name='broadcast-save-draft'
                    variant='outline'
                    onClick={onSaveDraft}
                    disabled={!canSaveDraft}
                    className='flex-1 sm:hidden!'
                >
                    Save Draft
                </StanButton>
            </div>
            {/* Desktop: Spacer */}
            <div className='flex-1' />
            <div className='flex flex-col gap-2 sm:flex-row'>
                <StanButton
                    name='broadcast-save-draft'
                    variant='outline'
                    onClick={onSaveDraft}
                    disabled={!canSaveDraft}
                    className='max-sm:hidden! sm:block'
                >
                    Save Draft
                </StanButton>
                {isSent ? (
                    <StanButton name='broadcast-sent' disabled className='w-full sm:w-auto'>
                        Sent
                    </StanButton>
                ) : isScheduled ? (
                    <StanButton
                        name='broadcast-reschedule'
                        onClick={onSend}
                        disabled={disabled}
                        className='w-full sm:w-auto'
                    >
                        Reschedule
                    </StanButton>
                ) : (
                    <StanButton name='broadcast-send' onClick={onSend} disabled={disabled} className='w-full sm:w-auto'>
                        Next
                    </StanButton>
                )}
            </div>
        </div>
    );
};
